export default __webpack_public_path__ + "static/media/ApplesOrangesMockup2.a62768c4.png";